import React, { useState } from 'react';
import StaticPageLayout from '../components/StaticPageLayout';
import { Mail, Clock, CheckCircle2, Copy } from 'lucide-react';

const SUPPORT_EMAIL = 'support@todaytheapp.com';

const topics = [
  { label: 'Account & login issues' },
  { label: 'Billing, refunds, subscriptions' },
  { label: 'A bug or something broken' },
  { label: 'Feature suggestions & feedback' },
  { label: 'Press, partnerships & collabs' },
];

export default function ContactPage() {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard?.writeText(SUPPORT_EMAIL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <StaticPageLayout testId="contact-page">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 py-12 sm:py-16">
        <p className="text-xs uppercase tracking-widest font-semibold mb-3" style={{ color: 'var(--primary)', fontFamily: 'Manrope' }}>
          Contact
        </p>
        <h1 className="text-4xl sm:text-5xl font-bold mb-5 leading-tight" style={{ fontFamily: 'Manrope', color: 'var(--text)' }}>
          We'd love to hear from you.
        </h1>
        <p className="text-lg leading-relaxed mb-10" style={{ color: 'var(--muted-fg)', fontFamily: 'Georgia, serif' }}>
          Whether you've hit a bug, want a feature, need help with a charge, or just want to say hi — our inbox is open.
        </p>

        {/* Single email card */}
        <div className="rounded-2xl border p-6 sm:p-8 mb-8"
          style={{ background: 'var(--surface)', borderColor: 'var(--border)' }}>
          <Mail className="w-6 h-6 mb-4" style={{ color: 'var(--primary)' }} />
          <p className="text-xs uppercase tracking-widest font-semibold mb-2"
            style={{ color: 'var(--muted-fg)', fontFamily: 'Manrope' }}>
            Email us at
          </p>
          <a href={`mailto:${SUPPORT_EMAIL}`}
            data-testid="contact-email-support"
            className="text-2xl sm:text-3xl font-bold block break-all mb-4"
            style={{ color: 'var(--text)', fontFamily: 'Manrope' }}>
            {SUPPORT_EMAIL}
          </a>
          <button onClick={copyEmail}
            data-testid="contact-copy-email"
            className="inline-flex items-center gap-1.5 text-sm font-medium transition-opacity hover:opacity-80"
            style={{ color: 'var(--primary)' }}>
            {copied ? <CheckCircle2 className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
            {copied ? 'Copied!' : 'Copy email'}
          </button>
        </div>

        <section className="rounded-2xl border p-6 sm:p-8 mb-10"
          style={{ background: 'var(--surface)', borderColor: 'var(--border)' }}>
          <h2 className="text-xl font-bold mb-4" style={{ fontFamily: 'Manrope', color: 'var(--text)' }}>
            Not sure where to start?
          </h2>
          <ul className="space-y-2.5">
            {topics.map((t, i) => (
              <li key={i} className="flex items-center justify-between gap-3">
                <span className="text-sm sm:text-[15px]" style={{ color: 'var(--text)' }}>
                  {t.label}
                </span>
                <a href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(t.label)}`}
                  data-testid={`contact-topic-${i}`}
                  className="text-xs sm:text-sm font-semibold transition-opacity hover:opacity-80 shrink-0"
                  style={{ color: 'var(--primary)' }}>
                  Email →
                </a>
              </li>
            ))}
          </ul>
        </section>

        <section className="rounded-2xl border p-6 flex items-start gap-4"
          style={{ background: '#F1F4EE', borderColor: '#C9D6BC' }}>
          <div className="w-10 h-10 rounded-full flex items-center justify-center shrink-0"
            style={{ background: '#8BAAA5', color: 'white' }}>
            <Clock className="w-5 h-5" />
          </div>
          <div>
            <h3 className="font-bold mb-1" style={{ fontFamily: 'Manrope', color: '#3B4F2A' }}>
              Typical response time
            </h3>
            <p className="text-sm" style={{ color: '#3B4F2A' }}>
              We reply within <strong>24 hours on weekdays</strong>, usually much sooner. Weekends may take a little longer — but we promise we're reading.
            </p>
          </div>
        </section>
      </div>
    </StaticPageLayout>
  );
}
